import firebase from 'firebase'

const firebaseConfig = {
    apiKey: "AIzaSyA3E36EKASeUTIXL5YJ3-gAkiPGsqNB79k",
    authDomain: "gokulportfolio-68c15.firebaseapp.com",
    databaseURL: "https://gokulportfolio-68c15.firebaseio.com",
    projectId: "gokulportfolio-68c15",
    storageBucket: "gokulportfolio-68c15.appspot.com",
    messagingSenderId: "791438107992",
    appId: "1:791438107992:web:5591049c306fa83414b12d",
    measurementId: "G-ZCDQR1BYP7"
}

firebase.initializeApp(firebaseConfig)
export default firebase